module.exports = __webpack_public_path__ + "static/drive1-f3205863e400b003be9ed7b82879c50a.jpg";